"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInvalidateBootstrapLegacyQuery = void 0;
var react_query_1 = require("react-query");
var cache_key_1 = require("./cache-key");
function useInvalidateBootstrapLegacyQuery() {
    var queryClient = (0, react_query_1.useQueryClient)();
    return function () { return queryClient.invalidateQueries((0, cache_key_1.cacheKey)()); };
}
exports.useInvalidateBootstrapLegacyQuery = useInvalidateBootstrapLegacyQuery;
